module.exports = __webpack_public_path__ + "img/svvkvikkleire.2d300bb9.jpg";